'use client';
export const handleCompositionStart = (setIsComposing) => {
    setIsComposing(true);
};
export const handleCompositionEnd = (setIsComposing) => {
    // Timeout to fix weirdness in Firefox for Pinyin IME
    setTimeout(() => {
        setIsComposing(false);
    }, 0);
};
export var InputErrorPlacement;
(function (InputErrorPlacement) {
    InputErrorPlacement["INLINE"] = "inline";
    InputErrorPlacement["LABEL"] = "label";
})(InputErrorPlacement || (InputErrorPlacement = {}));
export const AUTOCOMPLETE_TYPES = ['email', 'tel'];
//# sourceMappingURL=InputShared.js.map